module.exports = {
	"Aggressive Allocation": 20,
	"China Region": 2,
	"Commodities Focused": 1,
	"Communications": 25,
	"Consumer Cyclical": 40,
	"Consumer Defensive": 15,
	"Derivative Income": 1,
	"Diversified Emerging Mkts": 8,
	"Diversified Pacific/Asia": 6,
	"Energy Limited Partnership": 28,
	"Equity Energy": 51,
	"Equity Precious Metals": 28,
	"Europe Stock": 36,
	"Financial": 51,
	"Foreign Large Blend": 272,
	"Foreign Large Growth": 118,
	"Foreign Large Value": 142,
	"Foreign Small/Mid Blend": 28,
	"Foreign Small/Mid Growth": 40,
	"Foreign Small/Mid Value": 29,
	"Global Aggressive Allocation": 22,
	"Global Large-Stock Blend": 130,
	"Global Large-Stock Growth": 97,
	"Global Large-Stock Value": 60,
	"Global Moderate Allocation": 39,
	"Global Moderately Aggressive Allocation": 27,
	"Global Real Estate": 53,
	"Global Small/Mid Stock": 61,
	"Health": 89,
	"Industrials": 46,
	"Infrastructure": 43,
	"Japan Stock": 25,
	"Large Blend": 601,
	"Large Growth": 396,
	"Large Value": 440,
	"Mid-Cap Blend": 201,
	"Mid-Cap Growth": 169,
	"Mid-Cap Value": 169,
	"Miscellaneous Allocation": 3,
	"Miscellaneous Region": 41,
	"Miscellaneous Sector": 31,
	"Moderate Allocation": 98,
	"Moderately Aggressive Allocation": 33,
	"Moderately Conservative Allocation": 1,
	"Natural Resources": 76,
	"Pacific/Asia ex-Japan Stk": 5,
	"Real Estate": 93,
	"Small Blend": 244,
	"Small Growth": 154,
	"Small Value": 164,
	"Tactical Allocation": 24,
	"Target-Date 2025": 5,
	"Target-Date 2030": 35,
	"Target-Date 2035": 40,
	"Target-Date 2040": 44,
	"Target-Date 2045": 46,
	"Target-Date 2050": 46,
	"Target-Date 2055": 45,
	"Target-Date 2060": 44,
	"Target-Date 2065+": 59,
	"Technology": 171,
	"Utilities": 26
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersPeers.json
// module id = 924
// module chunks = 0